module.exports = __webpack_public_path__ + "img/解决方案_动力_绿.79c0ecfd.svg";